import React, { useState, ReactNode } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Tabs,
  Tab,
  Select,
  MenuItem,
  Button,
  Tooltip,
} from "@mui/material";
import exportImg from "../../assets/images/export.png";
import approvalImg from "../../assets/images/Request.png";
import AddIcon from "../../assets/images/AddIcon.svg";
import listIcon from "../../assets/images/Detail.png";
import dashboardicon from "../../assets/images/reimaginedashboard.svg";

interface TabCardsProps {
  title?: string;
  tabLabels: string[];
  children: ReactNode[];
  dropdownOptions?: string[];
  selectedValue?: string;
  onDropdownChange?: (value: string) => void;
  maxHeight?: string;
  minHeight?: string;
  cardMaxHeight?: string;
  showNominationForm?: boolean;
  ApprovalTable?: boolean;
  onNominationClick?: () => void;
  onApprovalTableClick?: () => void;
  addButton?: boolean;
  onButtonClick?: () => void;
  onTabChange?: (index: number) => void;
  titlePadding?: string;
  background?: string;
  fontSize?: string;
  SPOCApprovalDashboard?: boolean;
  SPOCApprovalDashboardClick?: () => void;
  SPOCReimagineDashboardClick?: () => void;
  onSubmittedTableClick?: () => void;
  submittedListingView?: boolean;
}

const TabCards: React.FC<TabCardsProps> = ({
  title,
  tabLabels,
  children,
  dropdownOptions,
  selectedValue,
  onDropdownChange,
  maxHeight,
  minHeight,
  cardMaxHeight,
  titlePadding,
  onNominationClick,
  showNominationForm,
  onApprovalTableClick,
  ApprovalTable,
  addButton,
  onButtonClick,
  background,
  onTabChange,
  fontSize,
  SPOCApprovalDashboardClick,
  SPOCReimagineDashboardClick,
  SPOCApprovalDashboard,
  submittedListingView,
  onSubmittedTableClick,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    if (onTabChange) onTabChange(newValue);
  };
  return (
    <Card
      elevation={0}
      square
      sx={{
        borderRadius: 0,
        boxShadow: "none",
        overflow: "hidden",
        maxHeight: maxHeight || "255px",
        minHeight: minHeight || "255px",
        background: background || "#5D5D5D",
        color: "#ffffff",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#212121",
          padding: titlePadding || 1.5,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography fontWeight="bold" color="#ffffff" className="f-16">
          {title}
        </Typography>
        <Box sx={{ display: "flex" }}>
          {/* Nomination Form Section---------- */}
          {showNominationForm && (
            <Tooltip title="Nomination Form" placement="top" arrow>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={onNominationClick}
              >
                <Typography
                  fontSize="12px !important"
                  sx={{ color: "#ffffff" }}
                >
                  Nomination Form
                </Typography>
                <img
                  src={exportImg}
                  alt="Nomination Form"
                  style={{ paddingLeft: "7px" }}
                />
              </Box>
            </Tooltip>
          )}
          {ApprovalTable && (
            <Tooltip title=" Approval Pending List " placement="top" arrow>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={onApprovalTableClick}
              >
                <img
                  src={approvalImg}
                  alt="Approval Table"
                  style={{ paddingLeft: "10px" }}
                />
              </Box>
            </Tooltip>
          )}{" "}
          {submittedListingView && (
            <Tooltip title="My Idea List" placement="top" arrow>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={onSubmittedTableClick}
              >
                <img
                  src={approvalImg}
                  alt="Approval Table"
                  style={{ paddingLeft: "10px" }}
                />
              </Box>
            </Tooltip>
          )}
          {SPOCApprovalDashboard && (
            <>
              <Tooltip title="REImagine Dashboard" placement="top" arrow>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={SPOCReimagineDashboardClick}
                >
                  <img
                    src={dashboardicon}
                    alt="REImagine Dashboard"
                    style={{ paddingLeft: "10px" }}
                  />
                </Box>
              </Tooltip>
              <Tooltip
                title="Implementation Pending View"
                placement="top"
                arrow
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={SPOCApprovalDashboardClick}
                >
                  <img
                    src={listIcon}
                    alt="Approval Table"
                    style={{ paddingLeft: "10px" }}
                  />
                </Box>
              </Tooltip>
            </>
          )}
          {/* Dropdown Section---------- */}
          {dropdownOptions && onDropdownChange && (
            <Select
              value={selectedValue || ""}
              onChange={(e) => onDropdownChange(e.target.value)}
              variant="standard"
              sx={{
                color: "white",
                fontSize: "12px",
                minWidth: "100px",
                paddingBottom: "2px",
                "& .MuiSelect-select": { paddingY: 0 },
                "& .MuiSelect-icon": { color: "#ffffff" },
                "&:before": { borderBottom: "1px solid #808080 !important" },
                "&:after": { borderBottom: "1px solid #808080 !important" },
                "&:hover:not(.Mui-disabled):before": {
                  borderBottom: "1px solid #808080 !important",
                },
              }}
              displayEmpty
            >
              {dropdownOptions.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          )}
          {addButton && onButtonClick && (
            <Button
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0px",
                width: "fit-content",
                minWidth: "fit-content",
              }}
            >
              <img
                src={AddIcon}
                alt="Add"
                width={20}
                height={20}
                onClick={onButtonClick}
              />
            </Button>
          )}
        </Box>
      </Box>

      {/* Tabs Section */}
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        sx={{
          backgroundColor: "#fff",
          borderBottom: "1px solid #808080",
          minHeight: "35px",
          height: "35px",
          paddingX: 1,
          background: background || "#5D5D5D",
          "& .MuiTabs-indicator": { backgroundColor: "#DAAA00", height: "2px" },
          "& .MuiTab-root": {
            textTransform: "none",
            fontFamily: "Montserrat, sans-serif",
            fontSize: fontSize || "12px",
            fontWeight: 400,
            letterSpacing: "3%",
            paddingX: "8px",
            lineHeight: "13.8px",
            minHeight: "35px",
            color: "#CCCCCC!important",
            background: background || "#5D5D5D",
          },
          "& .Mui-selected": {
            color: "#ffffff !important",
            fontWeight: 700,
          },
        }}
      >
        {tabLabels.map((label, index) => (
          <Tab sx={{ fontSize: "12px" }} key={index} label={label} />
        ))}
      </Tabs>

      <CardContent
        className="scrollbar"
        sx={{
          paddingX: 1,
          paddingY: 0,

          overflowY: "auto",
          maxHeight: cardMaxHeight || "250px",
          background: background || "#5D5D5D",
        }}
      >
        {children[activeTab]}
      </CardContent>
    </Card>
  );
};

export default TabCards;
